const RoutesPaths = {
  home: "/home",
  dashboard: "/dashboard",
  invoices: "/invoices",
  customers: {
    list: "/customers",
    view: (id: string) => `/customers/${id}`
  },
  subcontractors: "/subcontractors",
  suppliers: "/suppliers",
  team_management: "/team_management",
  account_deletion_requests: "/account_deletion_requests",
  reports: {
    list: "/reports",
    create: "/reports/new",
    createResume: (id: string) => `/reports/new/${id}`,
    view: (id: string) => `/reports/${id}`,
    edit: (id: string) => `/reports/${id}/edit`
  },
  //
  auth: {
    login: "/login",
    addEmail: "/add-email",
    whatsapp_login: "/whatsapp_login"
  },
  // NEW
  settings: {
    profile: "/settings",
    configuration: "/settings/configuration",
    company: "/settings/company",
    roles: "/settings/roles",
    templates: "/settings/templates",
    projectTemplates: "/settings/templates/project",
    projectTemplate: (id: string) => `/settings/templates/project/${id}`,
    documentTemplates: "/settings/templates/documents",
    permissions: "/settings/permissions",
    dashboardTemplates: "/settings/templates/dashboard",
    lists: "/settings/templates/lists",
    notifications: "/settings/notifications"
  },
  lead: {
    list: "/leads",
    listInactive: "/leads/inactive",
    listArchivedLegacy: "/leads/archived",
    add: "/leads/add",
    view: (id: string) => `/leads/${id}`,
    financial: (id: string) => `/leads/${id}/financial`,
    legacyEdit: (id: string) => `/leads/${id}/edit`
  },
  archive: {
    list: "/archive",
    leads: "/archive?tab=leads",
    projects: "/archive?tab=projects"
  },
  project: {
    grid: "/projects/",
    list: "/projects/list",
    add: "/projects/add",
    view: (id: string) => ({
      _layout: `/projects/${id}`,
      overview: `/projects/${id}`,
      milestones: `/projects/${id}/milestones`,
      commissions: `/projects/${id}/commissions`,
      finance: `/projects/${id}/finance`,
      invoices: `/projects/${id}/invoices`,
      files: `/projects/${id}/files`,
      tasks: `/projects/${id}/tasks`,
      logs: `/projects/${id}/logs`,
      allFiles: `/projects/${id}/files/albums/all-files`,
      album: (albumId: string) => `/projects/${id}/files/albums/${albumId}`,
      /** @deprecated replaced by `files` — kept so old links redirect */
      albums: `/projects/${id}/albums`,
      /** @deprecated replaced by `album` — kept so old links redirect */
      legacyAlbum: (albumId: string) => `/projects/${id}/albums/${albumId}`,
      /** @deprecated replaced by `files` — kept so old links redirect */
      documents: `/projects/${id}/documents`
    }),
    edit: (id: string) => `/projects/${id}/edit`
  },
  proposal: {
    list: "/proposals",
    view: (id: string) => `/proposals/${id}`,
    edit: (id: string) => `/proposals/${id}/edit`,

    add: Object.assign(
      (leadId: string) => `/proposals/add${`?leadID=${leadId}`}`,
      {
        toString: () => "/proposals/add"
      }
    )
  },
  contract: {
    list: "/contracts",
    view: (id: string) => `/contracts/${id}`,
    edit: (id: string) => `/contracts/${id}/edit`,

    add: Object.assign(
      (leadId: string, proposalId: string) =>
        `/contracts/add?${`leadID=${leadId}&proposalID=${proposalId}`}`,
      {
        toString: () => "/contracts/add"
      }
    )
  },
  documentTemplates: {
    add: "/document_templates/add",
    edit: (id: string) => `/document_templates/${id}/edit`
  },
  proposalDocument: {
    create: (templateId: string, leadId: string) =>
      `/proposal_templates/${templateId}/create/${leadId}`,
    edit: (id: string) => `/proposal_templates/${id}/edit`
  },
  contractDocument: {
    create: {
      path: `/contract_templates/:leadId/create`,
      url: (
        leadId: string,
        params?: Partial<Record<"templateId" | "proposalId", string>>
      ) => buildUrl(`/contract_templates/${leadId}/create`, params)
    },
    edit: (id: string) => `/contract_templates/${id}/edit`
  }
}

function buildUrl(base: string, params?: Record<string, string | undefined>) {
  if (!params) return base
  const query = new URLSearchParams(
    Object.entries(params).filter(
      (entry): entry is [string, string] => entry[1] !== undefined
    )
  ).toString()
  return query ? `${base}?${query}` : base
}

export { RoutesPaths }
